import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

import './styles/base.css'
import './styles/colors.css'

import PrimeVue from 'primevue/config'
import DatePicker from 'primevue/datepicker'

// ❗ v4에서는 primeicons만 CSS import
import 'primeicons/primeicons.css'

// 테마 preset import
import Aura from '@primevue/themes/aura'

const app = createApp(App)
const pinia = createPinia()

// PrimeVue 설정 (v4 핵심)
app.use(PrimeVue, {
  theme: {
    preset: Aura
  },

  locale: {
    startsWith: '시작',
    contains: '포함',
    notContains: '포함 안함',
    endsWith: '끝',
    equals: '같음',
    notEquals: '다름',
    noFilter: '필터 없음',

    dayNames: [
      '일요일',
      '월요일',
      '화요일',
      '수요일',
      '목요일',
      '금요일',
      '토요일'
    ],

    dayNamesShort: [
      '일',
      '월',
      '화',
      '수',
      '목',
      '금',
      '토'
    ],

    dayNamesMin: [
      '일',
      '월',
      '화',
      '수',
      '목',
      '금',
      '토'
    ],

    monthNames: [
      '1월',
      '2월',
      '3월',
      '4월',
      '5월',
      '6월',
      '7월',
      '8월',
      '9월',
      '10월',
      '11월',
      '12월'
    ],

    monthNamesShort: [
      '1월',
      '2월',
      '3월',
      '4월',
      '5월',
      '6월',
      '7월',
      '8월',
      '9월',
      '10월',
      '11월',
      '12월'
    ],

    today: '오늘',
    clear: '초기화',
    weekHeader: '주',
    firstDayOfWeek: 0
  }
})

app.component('DatePicker', DatePicker)

app.use(pinia)
app.use(router)
app.mount('#app')
